import type { App } from 'vue'

import { inputmask } from './directives/inputmask'

export default {
  install: (app: App) => {
    app.directive('mask', inputmask)
  },
}
